export const resolveMediaUrl = (url?: string | null) => {
  if (!url) {
    return "";
  }

  if (typeof window === "undefined") {
    return url;
  }

  const backendOrigin = `${window.location.protocol}//${window.location.hostname}:5000`;

  if (url.startsWith("/")) {
    return `${backendOrigin}${url}`;
  }

  const resolvedUrl = url.replace(/^https?:\/\/(localhost|127\.0\.0\.1):5000/i, backendOrigin);

  if (window.location.protocol === "https:") {
    return resolvedUrl.replace(/^http:\/\//i, "https://");
  }

  return resolvedUrl;
};

export const mediaFallbackUrl = "/product-placeholder.svg";

export const handleMediaError = (event: { currentTarget: HTMLImageElement }) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = mediaFallbackUrl;
};
